// extracted by mini-css-extract-plugin
export default {"accountItem":"style_accountItem__PHRjI","avatar":"style_avatar__IB9h5"};